/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: process.env.PUBLIC_URL + "/fonts/roboto-v20-latin-regular.ttf" });
Font.register({ family: "RobotoMedium", src: process.env.PUBLIC_URL + "/fonts/Roboto-Medium.ttf" });

const UtilsInstance = new Utils();

export class EthernetIPMonitorReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),

      // Summary
      firstOverviewPage: -1,
      firstLiveListPage: -1,
      firstInventoryPage: -1,
      firstPortsPage: -1,
      firstNetworkPage: -1,
      firstTopologyPage: -1,
      firstMediaCountersPage: -1,
      firstInterfaceCountersPage: -1,
      firstLogPage: -1,
      firstPingGraphPage: -1,

      // Summary numbering control
      isFirstOverviewPage: true,
      isFirstLiveListPage: true,
      isFirstInventoryPage: true,
      isFirstPortsPage: true,
      isFirstNetworkPage: true,
      isFirstTopologyPage: true,
      isFirstMediaCountersPage: true,
      isFirstInterfaceCountersPage: true,
      isFirstLogPage: true,
      isFirstPingGraphPage: true,

      // The report itself
      doc: ""
    };
  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getRectImage = (isFilled) => {
    if (isFilled) {
      return <Image src={process.env.PUBLIC_URL + "/images/filled-rect.png"} style={generalInfoStyles.rectangle} />;
    }
    else {
      return <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={generalInfoStyles.rectangle} />;
    }
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  formatLogTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString(Strings.DATE_LOCALE);
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      const eventTimeInMillis = logEntry.time * 1000;
      const uptimeInMillis = this.props.startTime * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - uptimeInMillis + eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString(Strings.DATE_LOCALE));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + " " + Strings.RELATIVE_YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + " " + Strings.RELATIVE_MONTH);
      }
      else {
        out.push(md + " " + Strings.RELATIVE_MONTHS);
      }
    }
    if (dd > 0) out.push(dd + " " + Strings.RELATIVE_DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + " " + Strings.RELATIVE_HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + " " + Strings.RELATIVE_MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={process.env.PUBLIC_URL + "/logo_report.png"} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.HEADER_TEXT}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, ${Strings.REPORT_PAGE} ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "overview" && this.state.isFirstOverviewPage) {
      this.setState({
        firstOverviewPage: pageNumber + 1,
        isFirstOverviewPage: false
      });
    }
    else if (reportPart === "livelist" && this.state.isFirstLiveListPage) {
      this.setState({
        firstLiveListPage: pageNumber + 1,
        isFirstLiveListPage: false
      });
    }
    else if (reportPart === "inventory" && this.state.isFirstInventoryPage) {
      this.setState({
        firstInventoryPage: pageNumber + 1,
        isFirstInventoryPage: false
      });
    }
    else if (reportPart === "ports" && this.state.isFirstPortsPage) {
      this.setState({
        firstPortsPage: pageNumber + 1,
        isFirstPortsPage: false
      });
    }
    else if (reportPart === "network" && this.state.isFirstNetworkPage) {
      this.setState({
        firstNetworkPage: pageNumber + 1,
        isFirstNetworkPage: false
      });
    }
    else if (reportPart === "topology" && this.state.isFirstTopologyPage) {
      this.setState({
        firstTopologyPage: pageNumber + 1,
        isFirstTopologyPage: false
      });
    }
    else if (reportPart === "mediaCounters" && this.state.isFirstMediaCountersPage) {
      this.setState({
        firstMediaCountersPage: pageNumber + 1,
        isFirstMediaCountersPage: false
      });
    }
    else if (reportPart === "interfaceCounters" && this.state.isFirstInterfaceCountersPage) {
      this.setState({
        firstInterfaceCountersPage: pageNumber + 1,
        isFirstInterfaceCountersPage: false
      });
    }
    else if (reportPart === "log" && this.state.isFirstLogPage) {
      this.setState({
        firstLogPage: pageNumber + 1,
        isFirstLogPage: false
      });
    }
    else if (reportPart === "pingGraph" && this.state.isFirstPingGraphPage) {
      this.setState({
        firstPingGraphPage: pageNumber + 1,
        isFirstPingGraphPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.REPORT_EXPORT_NAME}>
      {this.createGeneralInfoPage()}
      {this.createDataInfoPage()}
      {this.createSummaryPage()}
      {this.createLiveListPages()}
      {this.createInventoryPages()}
      {this.createPortsCountersPages()}
      {this.createNetworkPages()}
      {/* {this.createTopologyPages()} */}
      {this.createMediaCountersPages()}
      {this.createInterfaceCountersPages()}
      {this.createLogPages()}
      {this.createPingGraphPages()}
      {this.createDisclaimerPage()}
    </Document>;

    return doc;
  }

  // ----------------- General Information ---------------------
  createGeneralInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.GENERAL_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.CLIENT_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.PROJECT_NAME} {this.props.userInput.clientProjectName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME} {this.props.userInput.clientNetworkName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.LOCATION} {this.props.userInput.clientLocation}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_NAME} {this.props.userInput.clientCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.ACCOUNTABLE_NAME} {this.props.userInput.clientAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_ADDRESS} {this.props.userInput.clientAddress}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_CITY} {this.props.userInput.clientCity}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.COMPANY_TEL} {this.props.userInput.clientTel}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getClientImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.EXECUTING_COMPANY_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_COMPANY_NAME} {this.props.userInput.executingCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_ACCOUNTABLE_NAME} {this.props.userInput.executingAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_TEL} {this.props.userInput.executingTel}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.EXECUTING_EMAIL} {this.props.userInput.executingEmail}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getExecutorImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.ANNOTATIONS}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.notesSection}>
          <Text style={reusableStyles.normalText}>{this.props.userInput.notes}</Text>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.CONCLUSION}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.conclusionSection}>

          <View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_STRING}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM_W_RESTRICTION)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_W_RESTRICTION_STRING}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.NON_CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.NON_CONFORM_STRING}</Text>
            </View>

          </View>

          <View style={generalInfoStyles.signatureLine} />

        </View>

        {this.getPageFooter()}

      </Page >
    );
  }

  getClientImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a client image
    if (this.props.userInput.clientImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.clientImg} />
      );
    }
  }

  getExecutorImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a executor image
    if (this.props.userInput.executorImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.executorImg} />
      );
    }
  }

  // ----------------- Data Information ------------------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.MONITORING_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.NETWORK_TAG_DP}{this.props.tag} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_VERSION_DP}{Constants.TS_MONITOR_VERSION} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_TIME_ON_DP}{this.formatToRelativeTime(this.props.startTime)} </Text>
        <Text style={reusableStyles.normalText}>{Strings.REPORT_GENERATION}{this.getDateTimeNow()}</Text>
        <Text style={reusableStyles.normalText}>{Strings.NUM_OF_DEVICES_DP}{this.props.numOfDevices}</Text>
        <Text style={reusableStyles.normalText}>{Strings.NETWORK_AVAILABILITY_DP_2}{this.props.networkAvailability.toFixed(0).concat("%")}</Text>

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.ETHERNET_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.configData.addr} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.configData.netmask} </Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.configData.gateway} </Text>

        {this.getWlanOrOfficeInfo()}
        {this.getPageFooter()}

      </Page >
    );
  }

  getConfigModeText = (eth1Mode) => {
    if (eth1Mode === Constants.FIXED_IP_MODE) {
      return Strings.FIXED_IP;
    }
    else if (eth1Mode === Constants.DHCP_MODE) {
      return "DHCP";
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  getWlanOrOfficeInfo = () => {
    const doubleEthPorts = JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY));

    if (doubleEthPorts) {
      return (
        <>
          <Text style={reusableStyles.secondSubHeaderText}>{Strings.ETHERNET_OFFICE_INFO}</Text>
          <View style={reusableStyles.subHeaderLine} />
          <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.officeEthConfigData.eth1Addr}</Text>
          <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.officeEthConfigData.eth1Netmask}</Text>
          <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.officeEthConfigData.eth1Gateway}</Text>
          <Text style={reusableStyles.normalText}>{Strings.DNS_DP}{this.props.officeEthConfigData.eth1DNS}</Text>
          <Text style={reusableStyles.normalText}>{Strings.MODO_DP}{this.getConfigModeText(this.props.officeEthConfigData.eth1Mode)}</Text>
        </>
      );
    }
    else {
      return (
        <>
          <Text style={reusableStyles.secondSubHeaderText}>{Strings.WLAN_INFO}</Text>
          <View style={reusableStyles.subHeaderLine} />
          <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME_DP}{this.props.wifiConfigData.wifiName}</Text>
          <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.wifiConfigData.wifiAddr}</Text>
          <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.wifiConfigData.wifiNetmask}</Text>
          <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.wifiConfigData.wifiGateway}</Text>
        </>
      );
    }

  }
  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        <Text style={reusableStyles.summaryText} fixed>
          1. {Strings.LIVE_LIST} {Strings.LIVE_LIST_DOTS} {this.state.firstLiveListPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          2. {Strings.INVENTORY} {Strings.INVENTORY_DOTS} {this.state.firstInventoryPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          3. {Strings.PORTS} {Strings.PORTS_DOTS} {this.state.firstPortsPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          4. {Strings.NETWORK} {Strings.NETWORK_DOTS} {this.state.firstNetworkPage}
        </Text>

        {/* <Text style={reusableStyles.summaryText} fixed>
          5. {Strings.TOPOLOGY} {Strings.TOPOLOGY_DOTS} {this.state.firstTopologyPage}
        </Text> */}

        <Text style={reusableStyles.summaryText} fixed>
          5. {Strings.MEDIA_COUNTERS} {Strings.MEDIA_COUNTERS_DOTS} {this.state.firstMediaCountersPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          6. {Strings.INTERFACE_COUNTERS} {Strings.INTERFACE_COUNTERS_DOTS} {this.state.firstInterfaceCountersPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          7. {Strings.LOG} {Strings.LOG_DOTS} {this.state.firstLogPage}
        </Text>

        {this.getPingGraphAndDisclaimerTexts()}

        {this.getPageFooter()}

      </Page>
    );
  }

  getPingGraphAndDisclaimerTexts = () => {
    if (this.props.includesPingGraph) {
      return (
        <React.Fragment>
          <Text style={reusableStyles.summaryText} fixed>
            8. {Strings.PING_GRAPH} {Strings.PING_GRAPH_DOTS} {this.state.firstPingGraphPage}
          </Text>

          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `9. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_DOTS_2} ${totalPages}`
          )} fixed />
        </React.Fragment>
      );
    }
    else {
      return (
        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `8. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_DOTS} ${totalPages}`
        )} fixed />
      );
    }
  }

  // ----------------- Live List -----------------
  createLiveListPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={liveListStyles.page}>

        {this.getPageHeader()}
        <Text style={liveListStyles.pageTitle} fixed>{Strings.LIVE_LIST_PAGE_TITLE}</Text>

        <View style={liveListStyles.table}>
          {this.createLiveListTableHeader()}
          {this.createLiveListTable()}
        </View>

        {this.getLegend2()}

        {this.getPageFooter("livelist")}

      </Page>
    );
  }

  createLiveListTableHeader = () => {
    return (
      <View style={liveListStyles.tableRow} fixed>

        <View style={liveListStyles.ipTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={liveListStyles.macTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={liveListStyles.protTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.PROTOCOL}</Text>
        </View>

        <View style={liveListStyles.methodTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>
            {Strings.CONFIG_METHOD_1}{"\n"}
            {Strings.CONFIG_METHOD_2}
          </Text>
        </View>

        <View style={liveListStyles.pingTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>
            {Strings.CURRENT_PING} / {"\n"}
            {Strings.MEDIUM_PING}
          </Text>
        </View>

        <View style={liveListStyles.lostPacketsTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.LOST_PACKET_PERC}</Text>
        </View>

        <View style={liveListStyles.lostPacketsTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.AVAILABILITY}</Text>
        </View>

        <View style={liveListStyles.lostPacketsTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.STATUS}</Text>
        </View>

      </View>
    );
  }

  createLiveListTable = () => {
    return (
      this.props.livelist.map(device => (
        <View style={liveListStyles.tableRow} key={device.mac} wrap={false}>

          {this.createIpCell(device)}

          <View style={liveListStyles.macTableCol}>
            <Text style={liveListStyles.tableCell}>{UtilsInstance.treatUppercase(device.mac)}</Text>
          </View>

          <View style={liveListStyles.protocolTableCol}>
            <Text style={liveListStyles.tableCell}>{device.protocol}</Text>
          </View>

          {this.createConfigMethodCell(device)}
          {this.createPingCell(device.pingCurrent, device.pingAvg)}

          <View style={liveListStyles.lostPacketsTableCol}>
            <Text style={liveListStyles.tableCell}>
              {device.lostPings} / {device.lostPingsPercentage.toFixed(2) + "%"}
            </Text>
          </View>

          <View style={liveListStyles.lostPacketsTableCol}>
            <Text style={liveListStyles.tableCell}>{device.percentageAvailable.toFixed(0).concat("%")}</Text>
          </View>

          {this.createStatusCell(device)}

        </View>
      ))
    );
  }

  createIpCell = (device) => {
    if (device.isDuplicated) {
      return (
        <View style={liveListStyles.duplicatedIpTableCol}>
          <Text style={liveListStyles.tableCell}>{device.ip}</Text>
        </View>
      );
    }
    else {
      if (device.ip === "0.0.0.0") {
        return (
          <View style={liveListStyles.zeroIpTableCol}>
            <Text style={liveListStyles.tableCell}>{device.ip}</Text>
          </View>
        );
      } else {
        return (
          <View style={liveListStyles.ipTableCol}>
            <Text style={liveListStyles.tableCell}>{device.ip}</Text>
          </View>
        );
      }
    }
  }

  createConfigMethodCell = (device) => {
    if (device.config_method.includes("2")) {
      return (
        <View style={liveListStyles.dhcpConfigMethodCol}>
          <Text style={liveListStyles.tableCell}>{device.config_method}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={liveListStyles.methodTableCol}>
          <Text style={liveListStyles.tableCell}>{device.config_method}</Text>
        </View>
      );
    }
  }

  createPingCell = (pingCurrent, pingAvg) => {
    let pingCurrentText = pingCurrent === "-" ? pingCurrent : `${pingCurrent}${Strings.MILLISECONDS_SUFFIX}`;
    let pingAvgText = pingAvg === "-" ? pingAvg : `${pingAvg}${Strings.MILLISECONDS_SUFFIX}`;

    return (
      <View style={liveListStyles.pingTableCol}>
        <Text style={liveListStyles.tableCell}>{pingCurrentText} / {pingAvgText}</Text>
      </View>
    );

  }

  getLegend = () => {
    return (
      <View>
        <Text style={{
          marginTop: 8,
          marginBottom: 4,
          fontSize: 12,
          fontWeight: "bold",
          fontFamily: "RobotoMedium"
        }}>
          {Strings.REPORT_LEGEND}
        </Text>

        <View style={{ display: "inline-flex", flexDirection: "row", justifyContent: "flex-start", marginBottom: 4 }}>
          <View style={{ marginRight: 4, height: "10px", width: "20px", backgroundColor: "purple" }} />
          <Text style={{ fontSize: 10, fontFamily: "RobotoRegular" }}>
            {Strings.REPORT_DUPLICATE_IP_LEGEND}
          </Text>
        </View>

        <View style={{ display: "inline-flex", flexDirection: "row", justifyContent: "flex-start", marginBottom: 4 }}>
          <View style={{ marginRight: 4, height: "10px", width: "20px", backgroundColor: "#191970" }}></View>
          <Text style={{ fontSize: 10, fontFamily: "RobotoRegular" }}>
            {Strings.REPORT_DHCP_LEGEND}
          </Text>
        </View>
      </View>
    );
  }

  getLegend2 = () => {
    return (
      <View fixed style={{
        position: "absolute",
        bottom: 50,
        left: 40,
        right: 40
      }}>
        <Text style={{
          textAlign: "right",
          marginTop: 8,
          marginBottom: 4,
          fontSize: 12,
          fontWeight: "bold",
          fontFamily: "RobotoMedium"
        }}>
          {Strings.REPORT_LEGEND}
        </Text>

        <View style={{ display: "inline-flex", flexDirection: "row", justifyContent: "flex-end", marginBottom: 4 }}>
          <View style={{ marginRight: 4, height: "10px", width: "20px", backgroundColor: "purple" }} />
          <Text style={{ fontSize: 10, fontFamily: "RobotoRegular" }}>
            {Strings.REPORT_DUPLICATE_IP_LEGEND}
          </Text>
        </View>

        <View style={{ display: "inline-flex", flexDirection: "row", justifyContent: "flex-end", marginBottom: 4 }}>
          <View style={{ marginRight: 4, height: "10px", width: "20px", backgroundColor: "#191970" }}></View>
          <Text style={{ fontSize: 10, fontFamily: "RobotoRegular" }}>
            {Strings.REPORT_DHCP_LEGEND}
          </Text>
        </View>
      </View>
    );
  }

  createStatusCell = (device) => {
    if (device.status === Constants.OK) {
      return (
        <View style={liveListStyles.okTableStatusCol}>
          <Text style={liveListStyles.tableCell}>{Strings.OK_STRING}</Text>
        </View>
      );
    }
    else if (device.status === Constants.OFFLINE) {
      return (
        <View style={liveListStyles.offlineTableStatusCol}>
          <Text style={liveListStyles.tableCell}>{Strings.OFFLINE_STRING}</Text>
        </View>
      );
    }
    else if (device.status === Constants.ONLINE) {
      return (
        <View style={liveListStyles.onlineTableStatusCol}>
          <Text style={liveListStyles.tableCell}>{Strings.ONLINE_STRING}</Text>
        </View>
      );
    }
    else if (device.status === Constants.FAULT) {
      return (
        <View style={liveListStyles.faultTableStatusCol}>
          <Text style={liveListStyles.tableCell}>{Strings.FAULT_STRING}</Text>
        </View>
      );
    }



  }

  // ----------------- Inventory -----------------
  createInventoryPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={inventoryStyles.pageTitle} fixed>{Strings.INVENTORY_PAGE_TITLE}</Text>

        <View style={inventoryStyles.table}>
          {this.createInventoryTableHeader()}
          {this.createInventoryTable()}
        </View>

        {this.getPageFooter("inventory")}

      </Page>
    );
  }

  createInventoryTableHeader = () => {
    return (
      <View style={inventoryStyles.tableRow} fixed>

        <View style={inventoryStyles.ipTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={inventoryStyles.macTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={inventoryStyles.nameIdTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={inventoryStyles.nameIdTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.VENDOR_ID}</Text>
        </View>

        <View style={inventoryStyles.revCodeTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.REVISION}</Text>
        </View>

        <View style={inventoryStyles.revCodeTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.PRODUCT_CODE}</Text>
        </View>

        <View style={inventoryStyles.serialTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.SERIAL_NUMBER}</Text>
        </View>

        <View style={inventoryStyles.typeTableColHeader}>
          <Text style={inventoryStyles.tableCellHeader}>{Strings.DEVICE_TYPE}</Text>
        </View>

      </View>
    );
  }

  createInventoryTable = () => {
    return (
      this.props.inventory.map(device => (
        <View style={inventoryStyles.tableRow} key={device.id} wrap={false}>

          <View style={inventoryStyles.ipTableCol}>
            <Text style={inventoryStyles.tableCell}>{device.socket_sin_address}</Text>
          </View>

          <View style={inventoryStyles.macTableCol}>
            <Text style={inventoryStyles.tableCell}>{UtilsInstance.treatUppercase(device.id)}</Text>
          </View>

          <View style={inventoryStyles.nameIdTableCol}>
            <Text style={inventoryStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(device.product_name, false)}</Text>
          </View>

          <View style={inventoryStyles.nameIdTableCol}>
            <Text style={inventoryStyles.tableCell}>{device.vendor_id}</Text>
          </View>

          <View style={inventoryStyles.revCodeTableCol}>
            <Text style={inventoryStyles.tableCell}>{device.revision}</Text>
          </View>

          <View style={inventoryStyles.revCodeTableCol}>
            <Text style={inventoryStyles.tableCell}>{device.product_code}</Text>
          </View>

          <View style={inventoryStyles.serialTableCol}>
            <Text style={inventoryStyles.tableCell}>{device.serial_number}</Text>
          </View>

          <View style={inventoryStyles.typeTableCol}>
            <Text style={inventoryStyles.tableCell}>{device.device_type}</Text>
          </View>

        </View>
      ))
    );
  }

  // ------------------ Ports ------------------
  createPortsCountersPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={portsStyles.pageTitle} fixed>{Strings.PORTS_PAGE_TITLE}</Text>

        <View style={portsStyles.table}>
          {this.createPortsTableHeader()}
          {this.createPortsTable()}
        </View>

        {this.getPageFooter("ports")}

      </Page>
    );
  }

  createPortsTableHeader = () => {
    return (
      <View style={portsStyles.tableRow} fixed>

        <View style={portsStyles.ipTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.PRODUCT_NAME_N}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.INTERFACE_TYPE}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.DUPLEX_MODE}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.INTERFACE_SPEED}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.NEGOTIATION_STATUS}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.HARDWARE_FAILURE}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.INTERFACE_STATE}</Text>
        </View>

        <View style={portsStyles.restTableColHeader}>
          <Text style={portsStyles.tableCellHeader}>{Strings.LINK_STATUS}</Text>
        </View>

      </View>
    );
  }

  createPortsTable = () => {
    return (
      this.props.ports.map(device => (
        <View wrap={true} key={device.ip}>

          <View style={portsStyles.deviceTableRow} wrap={false}>

            <View style={portsStyles.ipTableCol}>
              <Text style={portsStyles.tableCell}>{device.ip}</Text>
            </View>

            <View style={portsStyles.restTableCol}>
              <Text style={portsStyles.tableCell}>{device.mac}</Text>
            </View>

            <View style={portsStyles.restTableCol}>
              <Text style={portsStyles.tableCell}>
                {UtilsInstance.addWhitespaceToLongStrings(device.name, false)}
              </Text>
            </View>

            <View style={portsStyles.whitespaceTableCol}>
              <Text style={portsStyles.tableCell}></Text>
            </View>
          </View>

          {
            device.instances.map(instance => (
              <View style={portsStyles.tableRow} key={instance.interface_label} wrap={false}>

                <View style={portsStyles.instanceLabelTableCol}>
                  <Text style={portsStyles.tableCell}>{instance.interface_label}</Text>
                </View>

                <View style={portsStyles.restTableCol}>
                  <Text style={portsStyles.tableCell}>{instance.interface_type}</Text>
                </View>

                <View style={portsStyles.restTableCol}>
                  <Text style={portsStyles.tableCell}>{instance.duplex}</Text>
                </View>

                {this.getSpeedCell(instance.interface_speed)}

                <View style={portsStyles.restTableCol}>
                  <Text style={portsStyles.tableCell}>{instance.negotiation_status}</Text>
                </View>

                <View style={portsStyles.restTableCol}>
                  <Text style={portsStyles.tableCell}>{instance.local_hardware_fault}</Text>
                </View>

                <View style={portsStyles.restTableCol}>
                  <Text style={portsStyles.tableCell}>{instance.interface_state}</Text>
                </View>

                {this.getLinkStatusCell(instance.link_status)}

              </View>
            ))
          }
        </View>

      ))
    );
  }

  getSpeedCell = (interface_speed) => {
    if (interface_speed !== "") {
      return (
        <View style={portsStyles.restTableCol}>
          <Text style={portsStyles.tableCell}>{interface_speed}{Strings.MEGABITS_PER_SECOND_SUFFIX}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={portsStyles.restTableCol}>
          <Text style={portsStyles.tableCell}></Text>
        </View>
      );
    }
  }

  getLinkStatusCell = (link_status) => {
    if (link_status === "Active") {
      return (
        <View style={portsStyles.activeTableCol}>
          <Text style={portsStyles.tableCell}>{Strings.ACTIVE}</Text>
        </View>
      );
    }
    else if (link_status === "Inactive") {
      return (
        <View style={portsStyles.inactiveTableCol}>
          <Text style={portsStyles.tableCell}>{Strings.INACTIVE}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={portsStyles.unknownTableCol}>
          <Text style={portsStyles.tableCell}>{Strings.UNKNOWN}</Text>
        </View>
      );
    }
  }

  // ----------------- Network -----------------
  createNetworkPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={networkStyles.pageTitle} fixed>{Strings.NETWORK_PAGE_TITLE}</Text>

        <View style={networkStyles.table}>
          {this.createNetworkTableHeader()}
          {this.createNetworkTable()}
        </View>

        {this.getPageFooter("network")}

      </Page>
    );
  }

  createNetworkTableHeader = () => {
    return (
      <View style={networkStyles.tableRow} fixed>

        <View style={networkStyles.ipTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={networkStyles.restTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.NETWORK_TOPOLOGY}</Text>
        </View>

        <View style={networkStyles.restTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.NETWORK_STATUS}</Text>
        </View>

        <View style={networkStyles.acdCapableTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.ACD_CAPABLE}</Text>
        </View>

        <View style={networkStyles.acdStatusTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.ACD_STATUS}</Text>
        </View>

        <View style={networkStyles.restTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.ANNOUNCE_BASED}</Text>
        </View>

        <View style={networkStyles.restTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.BEACON_BASED}</Text>
        </View>

        <View style={networkStyles.restTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.FLUSH_TABLE_CAPABLE}</Text>
        </View>

        <View style={networkStyles.restTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.REDUNDANT_GATEWAY_CAPABLE}</Text>
        </View>

        <View style={networkStyles.restTableColHeader}>
          <Text style={networkStyles.tableCellHeader}>{Strings.SUPERVISOR_CAPABLE}</Text>
        </View>

      </View>
    );
  }

  createNetworkTable = () => {
    return (
      this.props.networkDevices.map(device => (
        <View style={networkStyles.tableRow} key={device.id} wrap={false}>

          <View style={networkStyles.ipTableCol}>
            <Text style={networkStyles.tableCell}>{device.ip}</Text>
          </View>

          <View style={networkStyles.restTableCol}>
            <Text style={networkStyles.tableCell}>{device.network_topology}</Text>
          </View>

          <View style={networkStyles.restTableCol}>
            <Text style={networkStyles.tableCell}>{device.network_status}</Text>
          </View>

          <View style={networkStyles.acdCapableTableCol}>
            <Text style={networkStyles.tableCell}>{this.getTrueFalseCell(device.acd_capable)}</Text>
          </View>

          <View style={networkStyles.acdStatusTableCol}>
            <Text style={networkStyles.tableCell}>{device.acd_status}</Text>
          </View>

          <View style={networkStyles.restTableCol}>
            <Text style={networkStyles.tableCell}>{this.getTrueFalseCell(device.announce_based_ring_node)}</Text>
          </View>

          <View style={networkStyles.restTableCol}>
            <Text style={networkStyles.tableCell}>{this.getTrueFalseCell(device.beacon_based_ring_node)}</Text>
          </View>

          <View style={networkStyles.restTableCol}>
            <Text style={networkStyles.tableCell}>{this.getTrueFalseCell(device.flush_table_frame_capable)}</Text>
          </View>

          <View style={networkStyles.restTableCol}>
            <Text style={networkStyles.tableCell}>{this.getTrueFalseCell(device.redundant_gateway_capable)}</Text>
          </View>

          <View style={networkStyles.restTableCol}>
            <Text style={networkStyles.tableCell}>{this.getTrueFalseCell(device.supervisor_capable)}</Text>
          </View>

        </View>
      ))
    );
  }

  getTrueFalseCell(attribute) {
    if (typeof (attribute) === "boolean") {
      if (attribute === true) {
        return Strings.YES;
      }
      else {
        return Strings.NO;
      }
    }
    else {
      return attribute;
    }

  }

  // ----------------- Topology -----------------
  createTopologyPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={topologyStyles.pageTitle} fixed>{Strings.TOPOLOGY_PAGE_TITLE}</Text>

        <View style={topologyStyles.table}>
          {this.createTopologyPageHeader()}
          {this.createTopologyTable()}
        </View>

        {this.getPageFooter("topology")}

      </Page>
    );
  }

  createTopologyPageHeader = () => {
    return (
      <View style={topologyStyles.tableRow} fixed>

        <View style={topologyStyles.snmpTableColHeader}>
          <Text style={topologyStyles.tableCellHeader}>{Strings.SNMP}</Text>
        </View>

        <View style={topologyStyles.ipTableColHeader}>
          <Text style={topologyStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={topologyStyles.tableColHeader}>
          <Text style={topologyStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={topologyStyles.tableColHeader}>
          <Text style={topologyStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={topologyStyles.tableColHeader}>
          <Text style={topologyStyles.tableCellHeader}>{Strings.NEIGHBOUR_PORT_1} {Strings.NEIGHBOUR_PORT_2}</Text>
        </View>

        <View style={topologyStyles.ipTableColHeader}>
          <Text style={topologyStyles.tableCellHeader}>{Strings.NEIGHBOUR_IP}</Text>
        </View>

      </View>
    );
  }

  createTopologyTable = () => {
    return (
      this.props.topology.map(device => (
        <View wrap={true} key={device.ip}>
          <View wrap={false} style={topologyStyles.deviceTableRow}>

            <View style={topologyStyles.snmpTableCol}>
              <Text style={topologyStyles.tableCell}>{UtilsInstance.getYesNoFromBoolean(device.topologySNMP)}</Text>
            </View>

            <View style={topologyStyles.ipTableCol}>
              <Text style={topologyStyles.tableCell}>{device.ip}</Text>
            </View>

            <View style={topologyStyles.tableCol}>
              <Text style={topologyStyles.tableCell}>{device.mac}</Text>
            </View>

            <View style={topologyStyles.tableCol}>
              <Text style={topologyStyles.tableCell}></Text>
            </View>

            <View style={topologyStyles.tableCol}>
              <Text style={topologyStyles.tableCell}></Text>
            </View>

            <View style={topologyStyles.ipTableCol}>
              <Text style={topologyStyles.tableCell}></Text>
            </View>

          </View>

          {
            device.connections.map(connection => {
              return (
                <View wrap={false} style={topologyStyles.tableRow} key={connection.selfPort}>

                  <View style={topologyStyles.snmpTableCol}>
                    <Text style={topologyStyles.tableCell}></Text>
                  </View>

                  <View style={topologyStyles.ipTableCol}>
                    <Text style={topologyStyles.tableCell}></Text>
                  </View>

                  <View style={topologyStyles.tableCol}>
                    <Text style={topologyStyles.tableCell}></Text>
                  </View>

                  <View style={topologyStyles.tableCol}>
                    <Text style={topologyStyles.tableCell}>
                      {UtilsInstance.addWhitespaceToLongStrings(connection.selfPort, false)}
                    </Text>
                  </View>

                  <View style={topologyStyles.tableCol}>
                    <Text style={topologyStyles.tableCell}>
                      {UtilsInstance.addWhitespaceToLongStrings(connection.neighborPort, false)}
                    </Text>
                  </View>

                  <View style={topologyStyles.ipTableCol}>
                    <Text style={topologyStyles.tableCell}>{connection.neighborIP}</Text>
                  </View>

                </View>
              );
            })
          }

        </View>
      ))
    );
  }

  // ----------------- Media Counters -----------------
  createMediaCountersPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={mediaCountersStyles.pageTitle} fixed>{Strings.MEDIA_COUNTERS_PAGE_TITLE}</Text>

        <View style={mediaCountersStyles.table}>
          {this.createMediaCountersTableHeader()}
          {this.createMediaCountersTable()}
        </View>

        {this.getPageFooter("mediaCounters")}

      </Page>
    );
  }

  createMediaCountersTableHeader = () => {
    return (
      <View style={mediaCountersStyles.tableRow} fixed>

        <View style={mediaCountersStyles.ipTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.ALIGNMENET_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.CARRIER_SENSE_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.FCS_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.SINGLE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.MULTIPLE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.LATE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.EXCESSIVE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.DEFERRED_TRANSMISSION}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.FRAME_TOO_LONG}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.MAC_TRANSMIT_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.MAC_RECEIVE_ERRORS}</Text>
        </View>

      </View>
    );
  }

  createMediaCountersTable = () => {
    return (
      this.props.mediaCounters.map(device => {
        if (device.media_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
          return (
            <View wrap={true} key={device.id}>

              <View style={mediaCountersStyles.deviceTableRow} wrap={false}>

                <View style={mediaCountersStyles.ipTableCol}>
                  <Text style={mediaCountersStyles.tableCell}>{device.ip}</Text>
                </View>

                <View style={mediaCountersStyles.whitespaceTableCol}>
                  <Text style={mediaCountersStyles.tableCell}></Text>
                </View>
              </View>

              {
                device.instances.map(instance => (
                  <View style={mediaCountersStyles.tableRow} key={instance.interface_label} wrap={false}>

                    <View style={mediaCountersStyles.ipTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.interface_label}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.alignment_errors}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.carrier_sense_errors}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.fcs_errors}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.single_collisions}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.multiple_collisions}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.late_collisions}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.excessive_collisions}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.deferred_transmission}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.frame_too_long}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.mac_transmit_errors}</Text>
                    </View>

                    <View style={mediaCountersStyles.restTableCol}>
                      <Text style={mediaCountersStyles.tableCell}>{instance.mac_receive_errors}</Text>
                    </View>

                  </View>
                ))
              }
            </View>
          );
        }
        else if (device.media_counters_attr_supported === Constants.ATTR_SUP_FALSE) {
          return (
            <View wrap={false} key={device.ip}>

              <View style={mediaCountersStyles.deviceTableRow} wrap={false}>

                <View style={mediaCountersStyles.ipTableCol}>
                  <Text style={mediaCountersStyles.tableCell}>{device.ip}</Text>
                </View>

                <View style={mediaCountersStyles.whitespaceTableCol}>
                  <Text style={mediaCountersStyles.tableCell}>{Strings.MEDIA_COUNTERS_NOT_SUPPORTED}</Text>
                </View>
              </View>

            </View>
          );
        }
        else {
          return (
            <View wrap={false} key={device.ip}>

              <View style={mediaCountersStyles.deviceTableRow} wrap={false}>

                <View style={mediaCountersStyles.ipTableCol}>
                  <Text style={mediaCountersStyles.tableCell}>{device.ip}</Text>
                </View>

                <View style={mediaCountersStyles.whitespaceTableCol}>
                  <Text style={mediaCountersStyles.tableCell}>{Strings.MEDIA_COUNTERS_NOT_ANSWERED_YET}</Text>
                </View>
              </View>

            </View>
          );
        }
      })
    );
  }

  // ----------------- Interface Counters -----------------
  createInterfaceCountersPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={interfaceCountersStyles.pageTitle} fixed>{Strings.INTERFACE_COUNTERS_PAGE_TITLE}</Text>

        <View style={interfaceCountersStyles.table}>
          {this.createInterfaceCountersTableHeader()}
          {this.createInterfaceCountersTable()}
        </View>

        {this.getPageFooter("interfaceCounters")}

      </Page>
    );
  }

  createInterfaceCountersTableHeader = () => {
    return (
      <View style={interfaceCountersStyles.tableRow} fixed>

        <View style={interfaceCountersStyles.ipTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.TRAFFIC_KBPS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IN_DISCARDS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IN_ERRORS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IN_UNKNOWN_PROTOS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.TRAFFIC_KBPS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.OUT_DISCARDS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.OUT_ERRORS}</Text>
        </View>

      </View>
    );
  }

  createInterfaceCountersTable = () => {
    return (
      this.props.interfaceCounters.map(device => {
        if (device.iface_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
          return (
            <View wrap={true} key={device.id}>

              <View style={interfaceCountersStyles.deviceTableRow} wrap={false}>

                <View style={interfaceCountersStyles.ipTableCol}>
                  <Text style={interfaceCountersStyles.tableCell}>{device.ip}</Text>
                </View>

                <View style={interfaceCountersStyles.whitespaceTableCol}>
                  <Text style={interfaceCountersStyles.tableCell}></Text>
                </View>
              </View>

              {
                device.instances.map(instance => (
                  <View style={interfaceCountersStyles.tableRow} key={instance.interface_label} wrap={false}>

                    <View style={interfaceCountersStyles.ipTableCol}>
                      <Text style={interfaceCountersStyles.tableCell}>{instance.interface_label}</Text>
                    </View>

                    {this.getTrafficCell(instance.input_kbps)}
                    {this.getErrorDiscardCell(instance.in_discards)}
                    {this.getErrorDiscardCell(instance.in_errors)}

                    <View style={interfaceCountersStyles.restTableCol}>
                      <Text style={interfaceCountersStyles.tableCell}>{instance.in_unknown_protos}</Text>
                    </View>

                    {this.getTrafficCell(instance.exit_kbps)}
                    {this.getErrorDiscardCell(instance.out_discards)}
                    {this.getErrorDiscardCell(instance.out_errors)}

                  </View>
                ))
              }
            </View>
          );
        }
        else if (device.iface_counters_attr_supported === Constants.ATTR_SUP_FALSE) {
          return (
            <View wrap={false} key={device.id}>

              <View style={interfaceCountersStyles.deviceTableRow} wrap={false}>

                <View style={interfaceCountersStyles.ipTableCol}>
                  <Text style={interfaceCountersStyles.tableCell}>{device.ip}</Text>
                </View>

                <View style={interfaceCountersStyles.whitespaceTableCol}>
                  <Text style={interfaceCountersStyles.tableCell}>{Strings.INTERFACE_COUNTERS_NOT_SUPPORTED}</Text>
                </View>
              </View>
            </View>
          );
        }
        else {
          return (
            <View wrap={false} key={device.id}>

              <View style={interfaceCountersStyles.deviceTableRow} wrap={false}>

                <View style={interfaceCountersStyles.ipTableCol}>
                  <Text style={interfaceCountersStyles.tableCell}>{device.ip}</Text>
                </View>

                <View style={interfaceCountersStyles.whitespaceTableCol}>
                  <Text style={interfaceCountersStyles.tableCell}>{Strings.INTERFACE_COUNTERS_NOT_ANSWERED_YET}</Text>
                </View>
              </View>
            </View>
          );
        }
      })
    );
  }

  getTrafficCell = (kbps) => {
    if (kbps == "") {
      return (
        <View style={interfaceCountersStyles.restTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{Strings.ZERO_TRAFFIC}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={interfaceCountersStyles.restTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{kbps.toFixed(2)} Kbps</Text>
        </View>
      );
    }
  }

  getErrorDiscardCell = (counter) => {
    if (counter > 0) {
      return (
        <View style={interfaceCountersStyles.errorTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{counter}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={interfaceCountersStyles.restTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{counter}</Text>
        </View>
      );
    }
  }

  // ----------------- Log -----------------
  createLogPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={logStyles.page}>

        {this.getPageHeader()}
        <Text style={logStyles.pageTitle} fixed>{Strings.LOG_PAGE_TITLE}</Text>

        <View style={logStyles.table}>
          {this.createLogTableHeader()}
          {this.createLogTable()}
        </View>

        {this.getPageFooter("log")}

      </Page>
    );
  }

  createLogTableHeader = () => {
    return (
      <View style={logStyles.tableRow} fixed>

        <View style={logStyles.horaryTableColHeader}>
          <Text style={logStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={logStyles.tableColHeader}>
          <Text style={logStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={logStyles.tableColHeader}>
          <Text style={logStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={logStyles.tableColHeader}>
          <Text style={logStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={logStyles.tableColHeader}>
          <Text style={logStyles.tableCellHeader}>{Strings.TYPE}</Text>
        </View>

        <View style={logStyles.eventTableColHeader}>
          <Text style={logStyles.tableCellHeader}>{Strings.EVENT}</Text>
        </View>

      </View>
    );
  }

  createLogTable = () => {
    return (
      this.props.log.map(logEntry => (
        <View style={logStyles.tableRow} key={logEntry.id} wrap={true}>

          <View style={logStyles.horaryTableCol}>
            <Text style={logStyles.tableCell}>{this.formatLogTime(logEntry)}</Text>
          </View>

          <View style={logStyles.tableCol}>
            <Text style={logStyles.tableCell}>{logEntry.ip}</Text>
          </View>

          <View style={logStyles.tableCol}>
            <Text style={logStyles.tableCell}>{this.getMacValue(logEntry)}</Text>
          </View>

          <View style={logStyles.tableCol}>
            <Text style={logStyles.tableCell}>{this.getProductNameValue(logEntry)}</Text>
          </View>

          <View style={logStyles.tableCol}>
            <Text style={logStyles.tableCell}>{logEntry.type}</Text>
          </View>

          <View style={logStyles.eventTableCol}>
            <Text style={logStyles.tableCell}>{logEntry.description}</Text>
          </View>

        </View>
      ))
    );
  }

  getMacValue = (logEntry) => {
    if (logEntry.type === "IP duplicado") {
      let splitArray = logEntry.mac.split("/");
      return (
        splitArray.map(mac => (mac + "\n"))
      );
    }
    else {
      return logEntry.mac;
    }
  }

  getProductNameValue = (logEntry) => {
    if (logEntry.type === "IP duplicado") {
      let splitArray = logEntry.product_name.split("/");
      return (
        splitArray.map(product_name => (product_name + "\n"))
      );
    }
    else {
      return UtilsInstance.addWhitespaceToLongStrings(logEntry.product_name);
    }
  }

  // ----------------- Ping Graph -----------------
  createPingGraphPages = () => {
    if (this.props.includesPingGraph) {
      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={reusableStyles.page}>

          {this.getPageHeader()}

          <Text style={pingGraphStyles.pageTitle} fixed>{Strings.PING_GRAPH_PAGE_TITLE}</Text>

          {this.createPingGraphImages()}

          {this.getPageFooter("pingGraph")}
        </Page>
      );
    }
  }

  setPingGraphFirstPageNumber = (pageNumber) => {
    if (this.state.firstOscilloscopePage === -1) {
      this.setState({ firstOscilloscopePage: pageNumber });
    }
  }

  createPingGraphImages = () => {
    return (
      this.props.imgURIs.map(data => (
        <View key={data.ip} wrap={false}>
          <Text style={pingGraphStyles.waveTitle}>{data.ip}</Text>
          <Image src={data.graph.imgURI} style={pingGraphStyles.chartImgStyle} />
        </View>
      ))
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  }
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const generalInfoStyles = StyleSheet.create({
  notesSection: {
    maxWidth: "510pt",
    width: "90vw",
    height: "14vh"
  },

  conclusionSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "16vh"
  },

  rectangleSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },

  rectangle: {
    width: 28,
    height: 28,
    margin: "1vh vw"
  },
  signatureLine: {
    height: "1px",
    width: "40vw",
    backgroundColor: "black",
  }
});

const liveListStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  protTableColHeader: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  methodTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  pingTableColHeader: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  lostPacketsTableColHeader: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  duplicatedIpTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
    color: "white",
    backgroundColor: "purple"
  },

  zeroIpTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
    backgroundColor: "orange"
  },

  macTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  protocolTableCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  pingTableCol: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  methodTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  dhcpConfigMethodCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    color: "white",
    backgroundColor: "#191970"
  },

  lostPacketsTableCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  okTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  offlineTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#D3D3D3"
  },

  onlineTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ADD8E6"
  },

  faultTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "red"
  },
});

const inventoryStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  nameIdTableColHeader: {
    width: "18%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  revCodeTableColHeader: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  serialTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  typeTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCol: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  nameIdTableCol: {
    width: "18%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  revCodeTableCol: {
    width: "9%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  serialTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  typeTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  protocolTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  pingTableCol: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  dhcpConfigMethodCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    color: "white",
    backgroundColor: "#483D8B"
  },

  lostPacketsTableCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
});

const portsStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
    height: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  restTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  deviceTableRow: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  ipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  instanceLabelTableCol: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "70%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  restTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  activeTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  inactiveTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#dcdcdc"
  },

  unknownTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#dcdcdc"
  },
});

const networkStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  restTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  acdCapableTableColHeader: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  acdStatusTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  restTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  acdCapableTableCol: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  acdStatusTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

});

const topologyStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  deviceTableRow: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  snmpTableColHeader: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "18%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  snmpTableCol: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "18%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCol: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  }
});

const mediaCountersStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  restTableColHeader: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  deviceTableRow: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  ipTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "88%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  restTableCol: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  }
});

const interfaceCountersStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  restTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  deviceTableRow: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  ipTableCol: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "84%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  restTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  errorTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ff6600"
  },
});

const pingGraphStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "4vh"
  },

  chartImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    height: "55vh",
    width: "80vw"
  }
});

const logStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  eventTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  eventTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  }
});

export default EthernetIPMonitorReport;
